import React, { forwardRef, useMemo } from 'react'
import Loader from 'components/Shared/Loader'
import { theme } from 'theme'
import { IconButtonContainer } from './styles'
import { CSSProp } from 'particles/themes/styled'
import Tooltip from 'particles/Tooltip'

type ButtonSize = 'xs' | 's' | 'm' | 'l'
type ButtonType = 'filled' | 'outlined' | 'action' | 'tertiary'

interface ButtonProps {
    className?: string
    type?: 'button' | 'submit' | 'reset'
    size: ButtonSize
    customStyle?: CSSProp
    icon?: boolean
    children?: React.ReactChild
    iconRight?: boolean
    isDisable?: boolean
    isLoading?: boolean
    isActive?: boolean
    buttonType: ButtonType
    onClick?: (e?: any) => void
    id?: string
    tooltipText?: string
    fadeOnHover?: boolean
    disableFocusStyle?: boolean
}

const IconButton: React.ForwardRefRenderFunction<HTMLButtonElement, ButtonProps> = (
    {
        className,
        type,
        size,
        customStyle,
        children,
        buttonType,
        isActive = false,
        isDisable = false,
        disableFocusStyle = false,
        isLoading,
        onClick,
        id,
        tooltipText,
        fadeOnHover,
        ...props
    },
    ref,
) => {
    const buttonSize = useMemo(() => {
        switch (size) {
            case 'xs': {
                return { width: '23px', height: '23px' }
            }
            case 's': {
                return { width: '28px', height: '28px' }
            }
            case 'm': {
                return { width: '32px', height: '32px' }
            }
            case 'l': {
                return { width: '40px', height: '40px' }
            }
            default: {
                return { width: '28px', height: '28px' }
            }
        }
    }, [size])
    return (
        <Tooltip label={tooltipText}>
            <IconButtonContainer
                type={type}
                ref={ref}
                width={buttonSize.width}
                height={buttonSize.height}
                onClick={onClick}
                isActive={isActive}
                customStyle={customStyle}
                className={`${buttonType} ${isDisable && 'disable'} ${className}`}
                id={id}
                fadeOnHover={fadeOnHover}
                disableFocusStyle={disableFocusStyle}
                {...props}
            >
                {isLoading ? (
                    <Loader
                        size="s"
                        progressBackgroundColor={buttonType !== 'filled' ? 'rgba(0,139,255,0.2)' : undefined}
                        progressBarColor={buttonType !== 'filled' ? theme.newColors.primary300 : undefined}
                    />
                ) : (
                    <>{children && children}</>
                )}
            </IconButtonContainer>
        </Tooltip>
    )
}
export default forwardRef(IconButton)
